export const touristToBasePassportRestAPI = ({passport: {number = null, issueDate = null, expiryDate = null}}) => ({
    type: 'PASSPORT',
    number,
    issueDate,
    validTill: expiryDate,
})

const userInfoPassportToBasePassportRestAPI = ({number = null, issueDate = null, validTill = null}) => ({
    type: 'PASSPORT',
    number,
    issueDate,
    validTill,
})

export const userInfoToActivePassport = ({passports}) => passports.find(({active}) => active)

export const userInfoToBasePassportRestAPI = ({passports}) => {
    const activePassport = userInfoToActivePassport({passports})
    return activePassport ? userInfoPassportToBasePassportRestAPI(activePassport) : null
}
